import {useEffect, useState} from 'react'

import btcIcon from '@Static/images/currencies/btc.png'
import cn from 'clsx'

import { getValueWithCurrency } from '@App/helpers/toCurrency'

import { Select } from '../../../../../SpotOrderTrade/components/Select'
import {formatDate, formatTime, getTimestampFromPeriod, ReportsFilter, useSeeMarket} from '../../../../model'
import { Card } from '../Card'

import s from './styles.module.scss'
import {useAppSelector} from "@App/hooks";
import {useDispatch} from "react-redux";
import {marketAnalytics, popularAnalytics} from "@Redux/slices/reports/selectors";
import {asyncGetPopularAnalytics, MarketGroup} from "@Redux/slices/reports/ReportsSlice";
import {MarketIcon} from "@UI/crypto_exchange/desktop/components/common/MarketIcon";

enum SortBy {
  Volume = 'total_result',
  Number = 'trades_count',
}
const options = [
  { name: 'Trading volume', value: SortBy.Volume },
  { name: 'Number of trades', value: SortBy.Number },
]

export const PopularTrades = ({ filters }: {filters: ReportsFilter}) => {
  const [sortBy, setSortBy] = useState(SortBy.Volume)
  const selectedSort = options.find((op) => op.value === sortBy)

  const marketGroups = useAppSelector(popularAnalytics)
  const dispatch = useDispatch()
  const timestampFrom = getTimestampFromPeriod(filters.period)

  const args = {
    timestampInterval: {
      timestampFrom: timestampFrom,
      timestampTo:   null
    },
    sortBy: sortBy
  }

  useEffect(() => {
    dispatch(asyncGetPopularAnalytics(args))
  }, [filters.period, sortBy])

  return (
    <Card
      className={s.container}
      title="Most popular with other traders"
      contentClassName={s.content}
      headerRightElement={
        <Select
          value={sortBy}
          options={options}
          containerClassName={s.selectContainer}
          inputClassName={s.select}
          optionClassName={s.option}
          onChange={(val) => setSortBy(val as SortBy)}
        />
      }
    >
      <div className={s.header}>
        <div className={s.segment}>Market</div>
        <div className={cn(s.segment, s.end)}>{selectedSort?.name}</div>
      </div>
      <div className={s.trades}>
        <div className={s.trades}>
          {marketGroups.map((group) => (
            <TradeGroup key={group.market.id} group={group} sortBy={sortBy}/>
          ))}
        </div>
      </div>
    </Card>
  )
}

export const TradeGroup = ({ group, sortBy }: { group: MarketGroup, sortBy: string }) => {
  const { seeMarket } = useSeeMarket({
    sourceCurrency: group.market.source_instrument_code,
    targetCurrency: group.market.target_instrument_code,
  })
  return (
    <div className={s.trade} key={group.market.id} onClick={() => seeMarket()}>
      <div className={cn(s.segment, s.left)}>
        <MarketIcon
          className={s.icon}
          symbol={group.market.symbol}
        />
        <div className={s.content}>
          <div className={s.name}>
            {group.market.title}
          </div>
        </div>
      </div>
      {sortBy === SortBy.Number ?
        <div className={cn(s.segment, s.rightAlternative)}>
          <span className={s.badge}>{group.trades_count}</span>
        </div>
        :
        <div className={cn(s.segment, s.right, group.total_result <= 0 && s.negative)}>
          {getValueWithCurrency(group.market.target_instrument_code, group.total_result)}
        </div>
      }
    </div>
  )
}

